import React, { useRef, useEffect, useState } from 'react';
import { useCountUp } from 'react-countup';
import { gsap } from 'gsap';
import './Statistics.scss';

function Statistics3() {
  const barRef = useRef();
  const [showCounter, setShowCounter] = useState(false);

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: barRef.current,
        start: 'top 75%',
        end: 'top 75%',
        once: true,
        onEnter: () => {
          setShowCounter(true);
        }
      }
    });
    tl.to('#bar10', { width: '55.55%', duration: 1.2 }).to(
      '#bar18',
      { width: '100%', duration: 1.2 },
      '-=1.2'
    );
  }, []);

  const SimpleHook = ({ number, reference }) => {
    useCountUp({
      ref: reference,
      end: number,
      start: 0,
      duration: 1.2
    });
    return <span id={reference} />;
  };

  return (
    <figure className="statistics">
      <div className="statistics__graphic">
        <h3 className="statistics__graphic__title">
          First-time homebuyers now expect to stay much longer in their new homes
        </h3>
        <div className="statistics__graphic__graph" ref={barRef}>
          <p className="statistics__graphic__graph__copy year">2012</p>
          <div className="bar">
            <div className="bar-left" id="bar10" />

            <p className="bar-number" id="num10">
              {showCounter ? <SimpleHook number="10" reference="counter10" /> : `0`} years
            </p>
          </div>
        </div>

        <div className="statistics__graphic__graph">
          <p className="statistics__graphic__graph__copy year">2022</p>
          <div className="bar">
            <div className="bar-left" id="bar18" />
            <p className="bar-number " id="num82">
              {showCounter ? <SimpleHook number="18" reference="counter18" /> : `0`} years
            </p>
          </div>
        </div>
      </div>
      <figcaption className="captions">
        Source: NAR, <span className="italic">Profile of Home Buyers and Sellers</span>
      </figcaption>
    </figure>
  );
}

export default Statistics3;
